import { AxiosRequestConfigMethods } from "@/api/types";
import { brandUrl, fetchFromBrandedUrl } from "@/api/utils";
import { EnvironmentVariables } from "@/modules/common/types";
import {
  CustomerIdInfoDTO,
  UpdateCustomerIdInfoDTO,
} from "@/modules/property-tracks/dtos/customer-id-info";
import { AxiosResponse } from "axios";

export const getCustomerIdInfo = async (
  customerUid: string
): Promise<AxiosResponse<CustomerIdInfoDTO>> => {
  const apiUrl = brandUrl<CustomerIdInfoDTO>(
    `${EnvironmentVariables.NEW_CRM_BASE_API_URL}/customers/${customerUid}/customer-id-infos`
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.GET,
    },
  });
};

export const updateCustomerIdInfo = async (
  uid: string,
  data: UpdateCustomerIdInfoDTO
): Promise<AxiosResponse<CustomerIdInfoDTO>> => {
  const apiUrl = brandUrl<CustomerIdInfoDTO>(
    `${EnvironmentVariables.NEW_CRM_BASE_API_URL}/customer-id-infos/${uid}`
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.PATCH,
      data,
    },
  });
};
